import React from 'react';
import MobileDevPageVideoBtfPrimis from './primis/MobileDevPageVideoBtf';
const MobileDevPageVideoBtf = ({ safety = 'off', safetyState })=>{
    return /*#__PURE__*/ React.createElement(MobileDevPageVideoBtfPrimis, {
        safety: safety,
        safetyState: safetyState
    });
};
MobileDevPageVideoBtf.displayName = 'MobileDevPageVideoBtf';
export default MobileDevPageVideoBtf;
